
import { Component, Vue, Prop } from "vue-property-decorator";
import { SMUser } from "@/store";
import HelloWidgetTemplate from "@/components/Widgets/Templates/HelloWidgetTemplate.vue";
import Image from "@/assets/images/people/people-3.png";
import backgroundImageEmployer from "@/assets/images/widgets/background-1.png";

@Component({
  components: {
    HelloWidgetTemplate,
  },
})
export default class IdChecks extends Vue {
  @Prop({ type: String }) readonly jobTitle?: string;
  @Prop({ type: String }) readonly name?: string;
  @Prop({ type: String }) readonly caseType?: string;
  @Prop({ type: String }) readonly listType?: string;

  get isCandidate() {
    return SMUser.isCandidate;
  }

  get isEmployer() {
    return SMUser.isEmployer;
  }

  get computedProps() {
    const { jobTitle, name, list, listType } = this;

    const props = {
      title: this.$tc("title"),
      jobTitle,
      name,
      list,
      listType,
      tasksEnable: true,
      image: Image,
    };

    if (this.isEmployer) {
      Object.assign(props, {
        backgroundImage: backgroundImageEmployer,
      });
    }

    return props;
  }

  get list() {
    // NOTE: DEV-8219. Maybe we need to append new status and step "Additional data & documents";
    const role = SMUser.user?.role;

    if (!role) return [];

    const path = `list.${role}`;

    return this.$t(path) || [];
  }
}
